<div class="clear"></div>
<section class="banner">
  <div class="container py-4">
    <h1>Frequently Asked Questions</h1>
  </div>
</section>
<div class="clear py-4"></div>
<section class="container">
  <div class="accordion" id="FAQs">
    <div class="card mb-3" *ngFor="let record of Records; let i = index">
      <div class="card-header p-0" [attr.id]="'heading' + i">
        <h4 class="mb-0">
          <button class="btn btn-link btn-block text-left text-primary font-weight-semi-bold text_20" type="button"
            [attr.data-toggle]="'collapse'" [attr.data-target]="'#collapse' + i"
            [attr.aria-expanded]="i === 0 ? 'true' : 'false'" [attr.aria-controls]="'collapse' + i">
            {{record.Question}}
          </button>
        </h4>
      </div>
      <div [attr.id]="'collapse' + i" class="collapse" [ngClass]="{'show': i === 0}"
        [attr.aria-labelledby]="'heading' + i" data-parent="#FAQs">
        <div class="card-body">
          <p>{{record.Answer}}</p>
        </div>
      </div>
    </div>
  </div>
  <p>Send mail to <a href="mailto:info@ppra.org.pk">info@ppra.org.pk</a> with questions or comments about this web site.
  </p>
</section>
<div class="clear py-3"></div>